<template>
  <div>
    <b-card title="ECommerce User" class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <label for="perPage" class="form-label">Per page</label>
          <b-form-select id="perPage" v-model="perPage" :options="perPageOptions" class="w-auto"></b-form-select>
        </div>
      </div>
      <b-table 
        :items="userEntries" 
        :fields="fields" 
        responsive="sm" 
        bordered 
        :per-page="perPage" 
        :current-page="currentPage"
      >
        <template #cell(action)="data">
          <b-button variant="primary" @click="convertToCustomer(data.item)">
            Convert to Customer
          </b-button>
        </template>
      </b-table>
      <div class="d-flex justify-content-between align-items-center mt-3">
        <div>
          Showing {{ firstItem }} to {{ lastItem }} of {{ totalEntries }} entries
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalEntries"
          :per-page="perPage"
          align="right"
          size="sm"
        ></b-pagination>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BTable, BFormCheckbox, BButton, BModal, BForm, BFormGroup, BFormInput, BCard, BPagination, BFormSelect } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BTable,
    BFormCheckbox,
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BCard,
    BPagination,
    BFormSelect,
  },
  data() {
    return {
      showAddUserModal: false,
      fields: [
        { key: "userName", label: "Username", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "phoneNumber", label: "Phone", sortable: true },
        { key: "action", label: "Action" },
      ],
      userEntries: [],
      perPageOptions: [5, 10, 15, 20],
      perPage: 5,
      currentPage: 1,
      newUser: {
        firstName: "",
        lastName: "",
        email: "",
        username: "",
        phone: "",
        order: "",
      },
    };
  },
  computed: {
    ...mapGetters("exportModule", {
      loadingEcommerce: "loading",
      userEntries: "ecom"
    }),

    totalEntries() {
      return this.userEntries.length;
    },
    firstItem() {
      return this.userEntries.length ? (this.currentPage - 1) * this.perPage + 1 : 0;
    },
    lastItem() {
      const last = this.currentPage * this.perPage;
      return last > this.totalEntries ? this.totalEntries : last;
    },
  },
  methods: {
    ...mapActions("ecommerceModule", [
      "getUserListAction"
    ]),

    convertToCustomer(user) {
      console.log("Redirecting to create customer page for:", user);
      this.$router.push({
        path: "/customer/customer-add",
        // query: { userName: user.userName, email: user.email, phoneNumber: user.phoneNumber }
      });
    },
    addUser() {
      const { firstName, lastName, email, username, phone, order } = this.newUser;
      if (firstName && lastName && email && username && phone && order) {
        this.userEntries.push({
          username,
          email,
          phone,
          order,
          checked: false,
        });
        this.newUser = {
          firstName: "",
          lastName: "",
          email: "",
          username: "",
          phone: "",
          order: "",
        };
        this.showAddUserModal = false;
      } else {
        alert("Please fill in all fields.");
      }
    },
  },
  async mounted() {
    await this.getUserListAction()
      .then((response) => {
        console.log(response);
        this.userEntries = response;
        console.log("response", this.userEntries);
      })
      .catch((response) => {
        console.log(response);
      });
  },
};
</script>

<style scoped>
.d-flex {
  flex-wrap: wrap;
}
.gap-2 {
  gap: 0.5rem;
}
</style>